import { s, c, t } from '../val.config';

export const schema = s.object({
  header: s.string(),
  subHeader: s.string(),
  image: s.object({
    content: s.image(),
  }),
});

export type NotFound = t.inferSchema<typeof schema>;

export default c.define('/settings/notFound.val.ts', schema, {
  header: '404',
  subHeader: '',
  image: {
    content: {
      path: '/public/val/tech_anim_9afa9.gif',
      width: 599,
      height: 766,
      mimeType: 'image/gif',
      alt: 'Person som blir bortført av ufo',
    },
  },
});
